let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a2Jsp")).then(() => parcelRequire('kSakt'));